'use client';

import {
  trafficSourceTracking,
  traits,
  vizAnalytics,
  wrapInstall,
} from '@dealerportal/mosaic-features';
import { useEffect } from 'react';

type InstallEntry = {
  name: string;
  fn: (...args: unknown[]) => unknown;
  args: unknown[];
};

type Props = {
  clientName?: string;
  universalRetailerId?: string;
};

export function MosaicLoader({
  clientName: retailerName,
  universalRetailerId = '',
}: Props) {
  const application = 'dealerportal';
  const skipPageview = false;
  const kioskMode = false;

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const installs: InstallEntry[] = [
      {
        name: 'traits',
        fn: traits.install as (...args: unknown[]) => unknown,
        args: [
          { retailerName, application, skipPageview },
          { universalRetailerId },
        ],
      },
      {
        name: 'traffic-source-tracking',
        fn: trafficSourceTracking.install as (...args: unknown[]) => unknown,
        args: [{}],
      },
      {
        name: 'viz-analytics',
        fn: vizAnalytics.install as (...args: unknown[]) => unknown,
        args: [{ kiosk: kioskMode }, { universalRetailerId }],
      },
    ];

    for (const { name, fn, args } of installs) {
      (wrapInstall(name, fn) as (...args: unknown[]) => unknown)(...args);
    }
  }, [universalRetailerId, retailerName]);

  return null;
}
